'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Popover, PopoverContent, PopoverTrigger } from '@workspace/ui/components/popover';
import { cn } from '@workspace/ui/lib';
import { CircleHelp, type LucideIcon } from 'lucide-react';
import Link from 'next/link';
import { useCallback, useState } from 'react';
import { appTopHeaderActionSurfaceClassName } from './app-top-header';

export const HELP_DESK_URL = 'https://help.nativeteams.com/' as const;

export interface AppTopHeaderHelpMenuItem {
  label: string;
  icon: LucideIcon;
  href?: string;
  external?: boolean;
  onSelect?: () => void;
}

interface AppTopHeaderHelpMenuProps {
  triggerLabel: string;
  items: AppTopHeaderHelpMenuItem[];
  className?: string;
}

const helpMenuItemClassName =
  'text-neutral-200 dark:text-neutral-100 hover:bg-grey-50 dark:hover:bg-grey-900 flex h-12 w-full shrink-0 cursor-pointer items-center gap-2 rounded-2xl px-4 text-left text-base leading-4 font-medium';

export function AppTopHeaderHelpMenu({
  triggerLabel,
  items,
  className,
}: AppTopHeaderHelpMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = useCallback((onSelect?: () => void) => {
    setIsOpen(false);
    onSelect?.();
  }, []);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            appTopHeaderActionSurfaceClassName,
            'flex size-[30px] items-center justify-center rounded-full',
            'data-[state=open]:inset-ring-pink-400 data-[state=open]:inset-ring-1',
            className
          )}
          aria-label={triggerLabel}
        >
          <CircleHelp className="size-4 stroke-[1.75]" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="end"
        sideOffset={12}
        className="bg-grey-0 dark:bg-grey-1000 w-[285px] gap-[22px] rounded-3xl p-[22px]"
      >
        {items.map((item) => {
          const Icon = item.icon;
          const content = (
            <>
              <Icon className="size-6 shrink-0 stroke-2!" aria-hidden="true" />
              <p>{item.label}</p>
            </>
          );

          if (item.href) {
            return (
              <Link
                key={item.label}
                href={item.href}
                target={item.external ? '_blank' : undefined}
                rel={item.external ? 'noopener noreferrer' : undefined}
                className={helpMenuItemClassName}
                onClick={() => handleSelect(item.onSelect)}
              >
                {content}
              </Link>
            );
          }

          return (
            <button
              key={item.label}
              type="button"
              className={helpMenuItemClassName}
              onClick={() => handleSelect(item.onSelect)}
            >
              {content}
            </button>
          );
        })}
      </PopoverContent>
    </Popover>
  );
}
